import React, {Fragment} from 'react';

import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {ProtocolAccordion} from './components/ProtocolAccordion';
import {ProtocolCard} from './components/ProtocolCard';
import {ProtocolProps} from './types';

export function Protocol({protocol, handleViewMore}: ProtocolProps) {
	const {isEnabled} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_623_PROTOCOL);

	return (
		<Fragment>
			{isEnabled ? (
				<ProtocolCard protocol={protocol} handleViewMore={handleViewMore} />
			) : (
				<ProtocolAccordion protocol={protocol} />
			)}
		</Fragment>
	);
}
